export default __webpack_public_path__ + "static/media/ic_edit.e149e302.svg";